import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Segmented tab control for switching between a liveboard's sections on phone,
// e.g. "Working 50" / "Away 30". Both labels and counts stay visible so the
// agent can see each section at a glance and switch with a single tap.
export default function MobileSectionTabs({ onSelect, options, value }) {
  return (
    <TabList role="tablist">
      {options.map(option => {
        const isActive = option.key === value;
        return (
          <Tab
            $isActive={isActive}
            aria-selected={isActive}
            data-aid={`mobileSectionTab-${option.key}`}
            key={option.key}
            onClick={() => onSelect(option.key)}
            role="tab"
            type="button"
          >
            {option.label}
            <Count>{option.count}</Count>
          </Tab>
        );
      })}
    </TabList>
  );
}

MobileSectionTabs.propTypes = {
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number,
    })
  ).isRequired,
  value: PropTypes.string,
};

const TabList = styled.div`
  border-bottom: 1px solid ${p => p.theme.colors.gray300};
  display: flex;
`;

const Tab = styled.button`
  background: none;
  border: none;
  border-bottom: 2px solid ${p => (p.$isActive ? p.theme.colors.green400 : 'transparent')};
  color: ${p => (p.$isActive ? p.theme.colors.green400 : p.theme.colors.gray600)};
  cursor: pointer;
  flex: 1;
  font-size: ${p => p.theme.fontSize.base};
  font-weight: ${p => (p.$isActive ? p.theme.fontWeight.medium : p.theme.fontWeight.normal)};
  margin-bottom: -1px;
  padding: ${p => p.theme.spacing.medium};

  &:active {
    background-color: ${p => p.theme.colors.gray100};
  }
`;

const Count = styled.span`
  margin-left: ${p => p.theme.spacing.small};
`;
